import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { EnvelopeIcon, LockClosedIcon, EyeIcon, EyeSlashIcon } from '@heroicons/react/24/solid'
import {
	firebaseAuth,
	firebaseGetAuth
} from '../firebase/config';

import { Logo } from '../components/Images';
import Splash from '../components/Splash';


const LoginPage: React.FC = () => {
	const navigate = useNavigate();

	const [email, setEmail] = useState('');
	const [password, setPassword] = useState('');
	const [error, setError] = useState('');

	const [isProtectPassword, setIsProtectPassword] = useState<boolean>(false);
	const [isLoader, setIsLoader] = useState<boolean>(false);

	const handleLogin = async (e: React.FormEvent) => {
			e.preventDefault();
			
			try {
				setIsLoader(true);

				await sleep(500);
				await firebaseAuth.signInWithEmailAndPassword(firebaseGetAuth, email, password);
				
				setIsLoader(false);
				navigate('/');
			} catch (err: any) {
				setIsLoader(false);
				setError(err.message);
			}
	};

	const sleep = (ms: number) => {
		return new Promise((resolve) => setTimeout(resolve, ms));
	}

	return (
		<div className="flex items-center justify-center h-screen bg-primary w-full">
			{isLoader && <Splash/>}

			<div className="content-login">
				<div className="top-9 text-center mb-10">
					<p className="text-secondary font-bold text-3xl">Welcome!</p>
				</div>

				<form onSubmit={handleLogin} className='bg-white p-6 rounded-lg shadow-md'>
					<div className='justify-center items-center flex my-9'>
						<img src={Logo} alt="" width={200}/>
					</div>

					<h2 className="text-2xl mb-5 font-bold text-dark text-center">Sign In</h2>

					<div className='form-login'>
						<div className="mb-4">
							<div className="max-w-sm space-y-3">
								<div className="relative input-custom-icon">
									<input 
										type="email"
										value={email}
										onChange={(e) => setEmail(e.target.value)}
										required
										placeholder='Email'
										className="py-3
											px-4
											ps-11
											block
											w-full
											text-sm
											ms-5
											input-element
										"
									/>
									<div className="absolute inset-y-0 start left-3 flex items-center pointer-events-none z-20 ps-4 w-5">
										<EnvelopeIcon className="text-primary"/>
									</div>
								</div>
							</div>
						</div>
						<div className="mb-4">
							<div className="max-w-sm space-y-3">
								<div className="relative input-custom-icon">
									<button type="button" onClick={() => setIsProtectPassword(!isProtectPassword)} className="absolute inset-y-0 end right-3 flex items-center z-20 ps-4 w-5 cursor-pointer">
										{ !isProtectPassword && <EyeIcon className="text-primary"/> }
										{ isProtectPassword && <EyeSlashIcon className="text-primary"/> }
									</button>

									<input 
										type={isProtectPassword ? 'text' : 'password'}
										value={password}
										onChange={(e) => setPassword(e.target.value)}
										required
										placeholder='Password'
										className="py-3
											px-4
											ps-11
											block
											w-full
											text-sm
											ms-5
											input-element
										"
									/>
									<div className="absolute inset-y-0 start left-3 flex items-center pointer-events-none z-20 ps-4 w-5">
										<LockClosedIcon className="text-primary"/>
									</div>
								</div>
							</div>
						</div>

						{error && <p className="text-red-500">{error}</p>}

						<button
							type="submit"
							className="text-white py-2 px-4 mb-11 mt-6 rounded btn-primary w-full"
							disabled={isLoader}
						>
							Continue
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};

export default LoginPage;
